export const HIERARCHY_1 = 'Adobe Analytics';
export const PAGE_CHANGE = 'PAGE_CHANGE';
export const LINK_CLICK = 'LINK_CLICK';
export const ROUTE_CHANGE = 'ROUTE_CHANGE';
export const EY_DELIVERS = 'EY Pathway';
export const EY_PRODUCTS = 'EY Pathway';
export const SERVICE_LINE = 'People Advisory Service';
export const COUNTRY = 'US';
export const SUB_AREA = 'East Central';
export const TRACK_SEARCH = 'TRACK_SEARCH';

export const getEnvironment = value => {
  if (value === 'production') {
    return 'PROD';
  } else if (value === 'test') {
    return 'QA';
  } else {
    return 'DEV';
  }
};
